// src/pages/Favorites.jsx
import React, { useContext }       from 'react';
import { Link }                    from 'react-router-dom';
import { FavoritesContext }        from '../context/FavoritesContext';
import { CartContext }             from '../context/CartContext';
import Footer                      from '../Pages/Footer';
import { API_URL } from '../config/api';

export default function Favorites() {
  const { favorites, dispatch }      = useContext(FavoritesContext);
  const { dispatch: cartDispatch }   = useContext(CartContext);

  /* ---------- État vide ---------- */
  if (!favorites.length) {
    return (
      <section className="fav__empty">
        <h2 className="fav__title">Mes favoris</h2>
        <p>Vous n’avez encore aucun favori.</p>
        <Link to="/" className="btn btn-primary">Découvrir les produits</Link>
      </section>
    );
  }

  /* ---------- Liste des favoris ---------- */
  return (
    <>
      <section className="fav">
        <header className="fav__header">
          <h2 className="fav__title">Mes favoris</h2>
          <span className="fav__count">{favorites.length} article(s)</span>
        </header>

        <div className="fav__grid">
          {favorites.map(item => (
            <article className="favCard" key={item._id}>
              {/* image */}
              <Link to={`/product/${item._id}`} className="favCard__imgWrap">
                <img
                  src={`${API_URL}/uploads/${item.img}`}
                  alt={item.title}
                  loading="lazy"
                />
              </Link>

              {/* contenu */}
              <div className="favCard__info">
                <h4 className="favCard__title">{item.title}</h4>
                <p  className="favCard__meta">
                  {item.label} • {item.categorie}
                </p>
                <p  className="favCard__price">
                  {Number(item.price).toLocaleString()} FCFA
                </p>

                {/* actions (ajout panier) */}
                <button
                   className="circle-btn"
                  onClick={() =>
                    cartDispatch({ type: 'ADD_TO_CART', payload: item })
                  }
                  title="Ajouter au panier"
                >
                  <i className="fa-solid fa-cart-plus" />
                </button>
              </div>

              {/* suppression favori */}
              <button
                className="favCard__remove"
                onClick={() =>
                  dispatch({ type: 'REMOVE_FAV', payload: item._id })
                }
                title="Retirer des favoris"
              >
                <i className="fa-solid fa-trash-can" />
              </button>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}